<template>
  <RouterView />
</template>

<script>
import { READ, UPDATE } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Account',
      breadcrumb: {
        name: new Promise(resolve => {
          this
            .$sdk
            .account
            .read(this.$route.params.accountId)
            .then(account => resolve(account.name))
        }),
        route: { name: 'customerservice-accounts-account', params: { accountId: this.$route.params.accountId } }
      },
      sidebar: [
        {
          icon: ['fal', 'chart-line'],
          route: { name: 'customerservice-accounts-account-dashboard', params: { accountId: this.$route.params.accountId } },
          name: 'Dashboard'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account),
          icon: ['fal', 'file-user'],
          route: { name: 'customerservice-accounts-account-details', params: { accountId: this.$route.params.accountId } },
          name: 'Details'
        },
        {
          hidden: this.$user.cannot(UPDATE, this.$sdk.account),
          icon: ['fal', 'cogs'],
          route: { name: 'customerservice-accounts-account-configure', params: { accountId: this.$route.params.accountId } },
          name: 'Configure'
        },
        {
          hidden: this.$user.cannot(READ, 'account_contact'),
          icon: ['fal', 'address-book'],
          route: { name: 'customerservice-accounts-account-contacts', params: { accountId: this.$route.params.accountId } },
          name: 'Contacts'
        },
        {
          hidden: this.$user.cannot(READ, 'account_carriersetting'),
          icon: ['fal', 'person-carry'],
          route: { name: 'customerservice-accounts-account-carriers', params: { accountId: this.$route.params.accountId } },
          name: 'Carriers'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account_event) || true,
          icon: ['fal', 'history'],
          route: { name: 'customerservice-accounts-account-histories', params: { accountId: this.$route.params.accountId } },
          name: 'Histories'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'person-dolly'],
          route: { name: 'customerservice-accounts-account-pickups', params: { accountId: this.$route.params.accountId } },
          name: 'Pickups'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account_team),
          icon: ['fal', 'poll-people'],
          route: { name: 'customerservice-accounts-account-teams', params: { accountId: this.$route.params.accountId } },
          name: 'Teams'
        },
        {
          hidden: this.$user.cannot(READ, 'account_attachment'),
          icon: ['fal', 'paperclip'],
          route: { name: 'customerservice-accounts-account-attachments', params: { accountId: this.$route.params.accountId } },
          name: 'Attachments'
        },
        {
          hidden: this.$user.cannot(READ, 'account_note'),
          icon: ['fal', 'comment-alt'],
          route: { name: 'customerservice-accounts-account-notes', params: { accountId: this.$route.params.accountId } },
          name: 'Notes'
        }
      ]
    }
  }
}
</script>
